import React from "react";
import "./App.css";
import { Switch, Route } from "react-router-dom";

/* Font Awesome Imports */
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

/* Component Imports */
import NavBar from "./components/Navbar.js";
import Hero from "./components/Hero.js";
import Footer from "./components/Footer.js";
import Categories from "./components/Categories.js";
import MostPopular from "./components/MostPopular.js";
import ReadTimer from "./components/ReadTimer.js";
import ReadListForm from "./components/ReadListForm.js";
import PhilosophiesOfTime from "./components/PhilosophiesOfTime.js";
import AleviateAnxiety from "./components/AleviateAnxiety.js";
import MeditationIsKey from "./components/MeditationIsKey.js";
import GainGratitude from "./components/GainGratitude.js";
import Hobbies from "./components/Hobbies.js";
import Zen from "./components/Zen.js";
import MindfullnessMain from "./components/MindfullnessMain.js";
import MindfullnessPopTopics from "./components/MindfullnessPopTopics.js";
import AboutMindfullness from "./components/AboutMindfullness.js";
import ProfilePage from "./components/ProfilePage";
import ScrollToTop from "./components/ScrollToTop";

/* Library Creation */
library.add(fas);

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <NavBar />
      <Switch>
        <Route exact path="/">
          <Hero />
          <Categories />
          <MostPopular />
          <ReadTimer />
          <ReadListForm />
        </Route>
        <Route exact path="/mindfulness">
          <MindfullnessMain />
          <MindfullnessPopTopics />
          <AboutMindfullness />
          <ReadTimer />
        </Route>
        <Route exact path="/mindfulness/philosophies-of-time">
          <PhilosophiesOfTime />
        </Route>
        <Route exact path="/mindfulness/aleviate-anxiety">
          <AleviateAnxiety />
        </Route>
        <Route exact path="/mindfulness/meditation-is-key">
          <MeditationIsKey />
        </Route>
        <Route exact path="/mindfulness/gain-gratitude">
          <GainGratitude />
        </Route>
        <Route exact path="/mindfulness/hobbies-and-habits">
          <Hobbies />
        </Route>
        <Route exact path="/mindfulness/zen">
          <Zen />
        </Route>
        <Route exact path="/my-profile">
          <ProfilePage />
        </Route>
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
